<template>
  <div>
    <v-app-bar
      color="primary"
      col
      :class="{ transparent }"
      fixed
      elevate-on-scroll
    >
      <div class="d-flex align-center">
        <router-link :to="{ name: 'Home' }">
          <v-img
            alt="WeStore"
            class="shrink mr-2"
            :src="
              dark
                ? require('@/assets/images/logo-dark.png')
                : require('@/assets/images/logo-light.png')
            "
            transition="scale-transition"
            :width="$vuetify.breakpoint.smAndDown ? 150 : 150"
          />
        </router-link>
      </div>
      <v-app-bar-title> </v-app-bar-title>

      <v-spacer></v-spacer>
      <div v-if="isLoggedIn" class="mx-4 hidden-sm-and-down">
        <v-btn outlined color="white" :class="isRtl ? 'ml-4 capitalize':'mr-4 capitalize'" :to="handleFreight()">
          Portal
        </v-btn>
        <v-btn color="dark--text" @click="logoutUser">Logout </v-btn>
      </div>
      <div v-else class="mx-4 hidden-sm-and-down">
        <v-btn outlined color="white" :class="isRtl ? 'ml-4 capitalize':'mr-4 capitalize'" to="/dashboard">
          Login
        </v-btn>
        <v-btn color="dark--text" to="/dashboard"> Sign Up </v-btn>
      </div>

      <v-app-bar-nav-icon
        @click.stop="mobileMenu = !mobileMenu"
        class="hidden-md-and-up white--text"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      color="#0C1922"
      v-model="mobileMenu"
      right
      app
      absolute
      temporary
    >
      <v-list nav dense>
        <v-row class="text-center">
          <v-col>
            <v-btn text style="height: auto" class="pa-3 my-2" href="/">
              <div class="d-flex flex-column white--text">
                <v-icon> mdi-phone </v-icon>
                <small> Phone </small>
              </div>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn text style="height: auto" class="pa-3 my-2" href="/">
              <div class="d-flex flex-column white--text">
                <v-icon> mdi-whatsapp </v-icon>
                <small> WhatsApp </small>
              </div>
            </v-btn>
          </v-col>
        </v-row>
        <v-list-item-group class="white--text">
          <v-divider />
          <v-list-item to="/dashboard" class="white--text">
            <v-list-item-title class="fs-5">Sign Up</v-list-item-title>
          </v-list-item>
          <v-divider />

          <v-list-item to="/dashboard" class="white--text">
            <v-list-item-title class="fs-5">Log In</v-list-item-title>
          </v-list-item>

          <!-- GET A QUOTE -->
          <v-divider />

          <v-list-item href="/quotes/create" class="white--text">
            <v-list-item-title class="fs-5"> Get A Quote </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { base } from "../mixins/base";
import { mapGetters } from "vuex";

export default {
  name: "ws-app-bar",
  mixins: [base],
  props: {
    dark: {
      type: Boolean,
    },
    transparent: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      freight: ["auth/freight"],
    }),
  },
  data: () => ({
    mobileMenu: false,
  }),
  methods: {
    handleFreight() {
      if (this.freight == true) {
        return "/insights";
      } else {
        return "/dashboard";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer{
  position: fixed;
}
</style>
